import { API_URL, API_ROOT } from '../config';

export const baseURL = API_URL;
export const apiRoot = API_ROOT;

export const PLACEHOLDER_IMAGE = 'data:image/svg+xml,' + encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" width="300" height="300">
  <defs>
    <linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#fdfbf7"/>
      <stop offset="100%" stop-color="#f3ede2"/>
    </linearGradient>
  </defs>
  <rect width="300" height="300" fill="url(#bg)"/>
  <rect x="15" y="15" width="270" height="270" rx="16" fill="none" stroke="#e6decb" stroke-width="2" stroke-dasharray="6 6"/>
  <g transform="translate(110, 85)" fill="none" stroke="#8a8f1d" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
    <rect x="0" y="8" width="80" height="60" rx="10" fill="#ffffff" fill-opacity="0.85"/>
    <circle cx="40" cy="38" r="16"/>
    <circle cx="62" cy="22" r="3" fill="#8a8f1d"/>
    <path d="M28 8 L34 0 L46 0 L52 8"/>
  </g>
  <text x="150" y="195" text-anchor="middle" fill="#2d3748" font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" font-size="16" font-weight="700" letter-spacing="0.5">Image Coming Soon</text>
  <text x="150" y="220" text-anchor="middle" fill="#8a8f1d" font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" font-size="12" font-weight="600" letter-spacing="1">CAKERESTRO</text>
</svg>`
);

export function imageUrl(path) {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return API_ROOT + path;
}

export const urls = {
  banners: `${baseURL}/banners`,
  popularCategories: `${baseURL}/categories/popular`,
  categoryTree: `${baseURL}/categories/nav`,
  categoriesByType: (type) => `${baseURL}/categories/by-type/${type}`,
  reviewTestimonials: `${baseURL}/reviews/testimonials`,
  products: `${baseURL}/products`,
  productBySlug: (slug) => `${baseURL}/products?slug=${slug}`,
  productsByCategory: (slug, params) => {
    let url = `${baseURL}/products?category=${slug}`;
    if (params?.sort) url += `&sort=${params.sort}`;
    if (params?.minPrice) url += `&minPrice=${params.minPrice}`;
    if (params?.maxPrice) url += `&maxPrice=${params.maxPrice}`;
    if (params?.page) url += `&page=${params.page}`;
    if (params?.limit) url += `&limit=${params.limit}`;
    if (params?.q) url += `&q=${encodeURIComponent(params.q)}`;
    return url;
  },
  randomProducts: (limit = 8) => `${baseURL}/products/random?limit=${limit}`,
  bestSelling: (limit = 10) => `${baseURL}/products/best-selling?limit=${limit}`,
  relatedProducts: (id, limit = 8) => `${baseURL}/products/related/${id}?limit=${limit}`,

  // Auth
  authLogin: `${baseURL}/auth/login`,
  authRegister: `${baseURL}/auth/register`,
  authMe: `${baseURL}/auth/me`,

  // Cart
  cart: `${baseURL}/cart`,
  cartItem: (id) => `${baseURL}/cart/${id}`,

  // Orders
  orders: `${baseURL}/orders`,
  orderById: (id) => `${baseURL}/orders/${id}`,
  orderCreate: `${baseURL}/orders/create`,
  orderVerify: `${baseURL}/orders/verify`,
  orderCancel: (id) => `${baseURL}/orders/${id}/cancel`,

  // Addresses
  addresses: `${baseURL}/addresses`,
  addressById: (id) => `${baseURL}/addresses/${id}`,

  // Blogs
  blogs: `${baseURL}/blogs`,
  blogBySlug: (slug) => `${baseURL}/blogs/${slug}`,

  // Coupons
  couponApply: `${baseURL}/coupons/apply`,

  // Pincodes
  pincodeCheck: `${baseURL}/pincodes/check?pincode=`,
  pincodeVerify: `${baseURL}/pincodes/verify`,

  // Newsletter
  newsletterSubscribe: `${baseURL}/newsletter/subscribe`,

  // Custom Cakes
  customCakes: `${baseURL}/custom-cakes`,
};
